import {TransferType} from '@sollapay/enums';

import type {PayinTransferType} from '@sollapay/enums';

export const DEFAULT_PAYMENT_TRANSFER_TYPE: PayinTransferType = TransferType.MASAV;
